import mitt from "mitt";
import { createContext, useContext } from "react";

const emitter = mitt();

export interface MittContextType {
  emitter: any;
}

const MittContext = createContext<MittContextType>({ emitter });

export const MittProvider = ({ children }: { children: any }) => {
  return <MittContext.Provider value={{ emitter }}>{children}</MittContext.Provider>;
};

export const useMitt = (): MittContextType => useContext(MittContext);
